/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PauseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2IconButtonPause1 from 'DesignSystem/Svgs/Tysiav2IconButtonPause1/index'



/** @type {import('Simple/types.js').View} */
export default function PauseAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Recording/PauseAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
 title="Pause"
 data="recorder"
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2IconButtonPause1
{...childProps}
  viewPath={`${viewPath}/Tysiav2IconButtonPause1`}
 fill2={dtColorsNeutral700}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}